import { IPageParam } from '../../types/common';

/** 分页查询请求参数 */
export interface IDistributionTaskPageRequest extends IPageParam {
  /** 任务编码 */
  code?: string;
  /** 特代ID */
  agentId?: number;
  /** 服务商ID */
  serverId?: number;
  /** 状态(0草稿,1待审批,2审批通过,3已驳回,4作废) */
  status?: number;
  /** 结算周期开始 */
  settlementDateStart?: string;
  /** 结算周期结束 */
  settlementDateEnd?: string;
  /** 提交人 */
  submitter?: string;
  /** 提交时间开始 */
  createTimeStart?: string;
  /** 提交时间结束 */
  createTimeEnd?: string;
}

/** 分页查询响应数据项 */
export interface IDistributionTaskDetail {
  /** 任务ID */
  id: number;
  /** 任务编码 */
  code: string;
  /** 结算周期开始 */
  settlementDateStart: string;
  /** 结算周期结束 */
  settlementDateEnd: string;
  /** 结算周期 */
  settlementDate: string;
  /** 特代ID */
  agentId: number;
  /** 特代名称 */
  agentName: string;
  /** 服务商ID */
  serverId: number;
  /** 服务商名称 */
  serverName: string;
  /** 企业支付金额 */
  successAmount: number;
  /** 阶段 */
  level: number;
  /** 阶段（展示） */
  levelStr: string;
  /** 成功结算金额 */
  successSettlementAmount: number;
  /** 总服务费 */
  serviceAmount: number;
  /** 推广费率 */
  protectLineRate: number;
  /** 保线金额 */
  protectLineAmount: number;
  /** 保线外金额 */
  outLineAmount: number;
  /** 保险外分润模式(0下级优先) */
  lineType: number;
  /** 状态(0草稿,1待审批,2审批通过,3已驳回,4作废) */
  status: number;
  /** 状态(展示) */
  statusStr: string;
  /** 提交人 */
  submitter: string;
}

/** 分页查询响应 */
export interface IDistributionTaskPageResponse {
  /** 数据列表 */
  data: IDistributionTaskDetail[];
  /** 总数 */
  total: number;
}

/** 新建分润任务请求参数 */
export interface IDistributionTaskAddRequest {
  /** 特代ID */
  agentId?: number;
  /** 服务商ID */
  serverId?: number;
  /** 结算周期开始 */
  settlementDateStart?: string;
  /** 结算周期结束 */
  settlementDateEnd?: string;
  /** 推广费率 */
  protectLineRate?: number;
  /** 结算周期 */
  settlementDate?: string[];
  /** 阶段 */
  levelStr?: string;
  /** 任务ID */
  id?: number;
}

/** 分润任务状态 */
export enum EDistributionTaskStatus {
  /** 全部 */
  All = '',
  /** 草稿 */
  Draft = 0,
  /** 审核中 */
  PendingApproval = 1,
  /** 通过 */
  Approved = 2,
  /** 驳回 */
  Rejected = 3,
  /** 作废 */
  Cancelled = 4,
}

export const distributionTaskStatusLabel = {
  [EDistributionTaskStatus.All]: '全部',
  [EDistributionTaskStatus.Draft]: '草稿',
  [EDistributionTaskStatus.PendingApproval]: '审核中',
  [EDistributionTaskStatus.Approved]: '通过',
  [EDistributionTaskStatus.Rejected]: '驳回',
  [EDistributionTaskStatus.Cancelled]: '作废',
};

export const distributionTaskStatusStyle = {
  [EDistributionTaskStatus.All]: 'default',
  [EDistributionTaskStatus.Draft]: 'default',
  [EDistributionTaskStatus.PendingApproval]: 'warning',
  [EDistributionTaskStatus.Approved]: 'success',
  [EDistributionTaskStatus.Rejected]: 'danger',
  [EDistributionTaskStatus.Cancelled]: 'danger',
};

/** 结算单报表数据 */
export interface IDistributionSettlementReport {
  /** 企业名称 */
  companyName: string;
  /** 企业支付金额 */
  successAmount: number;
  /** 总结算金额 */
  successSettleAmount: number;
  /** 服务商名称 */
  serverName: string;
  /** 结算服务费率 */
  serviceRate: number;
  /** 推广费率 */
  protectLineRate: number;
  /** 成本费率 */
  agentRate: number;
  /** 保线外金额 */
  outLineAmount: number;
  /** 溢价服务费 */
  inLineAmount: number;
}

/** 结算单明细数据 */
export interface IDistributionSettlement {
  /** 代理商名称 */
  agentName: string;
  /** 代理商直属企业列表 */
  agentTopCompanyList: IDistributionSettlementReport[];
  /** 代理商渠道列表 */
  agentTopAgentList: IDistributionSettlementReport[];
}

/** 结算单详情数据 */
export interface IDistributionTaskDetail {
  /** 结算单明细列表 */
  resultList: IDistributionSettlement[];

}
